module.exports = __webpack_public_path__ + "static/img/__9158.0c50e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9158.jpg
// module id = G0Ba
// module chunks = 0